var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pagina-construccion',{attrs:{"nombreApartado":"Transparencia","enlace":"http://www.haciendachiapas.gob.mx/"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }